module.exports = __webpack_public_path__ + "fonts/DIN Alternate Bold.61268bf5.ttf";